import React from 'react';

export const STARTER_OPTIONS = [
  'I need to automate a manual process',
  "I have data but can't act on it",
  'I want to build something with AI',
];

export default function StarterChips({ onSelect }) {
  return (
    <div className="starter-chips" data-testid="starter-chips" role="group" aria-label="Quick start options">
      {STARTER_OPTIONS.map((option, index) => (
        <button
          key={option}
          type="button"
          className="starter-chip"
          onClick={() => onSelect && onSelect(option)}
          data-testid={`starter-chip-${index}`}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
